import React, { useMemo } from 'react';
import injectSheet from 'react-jss';
import SVGInline from 'react-svg-inline';

import errorWarningIcon from '../images/alertErrorTriangle.svg';


const Alert = ({text, type, classes}) => {

    const containerClass = useMemo(() => {
        if(type === 'error'){
            return classes.errorStyle;
        }
       return '';
    }, [type]);


    const icon = useMemo(() => {
        if(type === 'error'){
            return errorWarningIcon;
        }
        return '';
    }, [type])

  return (
      <div className={`${classes.container} ${containerClass}`}>
         <SVGInline svg={icon} className={`${classes.icon}`} />
         <span className={classes.text}>{text}</span>
      </div>
  )
}

const style = {
    container: {
        height: '50px',
        borderRadius: '5px',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '16px',
    },
    icon:{
        width :'20px',
        height :'20px',
    },
    text: {
        fontSize: '12.8px',
        fontWeight: '400',
        fontFamily: 'Open Sans',
        marginLeft: '8px'

    },
    errorStyle: {
        backgroundColor : '#FCECF0',
        color: '#E57373'
    }
}
export default injectSheet(style)(Alert);
